// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-review-dialog {
  width: 100%;
  max-width: 520px;
  box-sizing: border-box;
}
.report-review-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
}
.report-review-dialog .dialog-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
}
.report-review-dialog .dialog-header .close-btn {
  color: #64748b;
}
.report-review-dialog .dialog-content {
  padding: 16px 20px;
}
.report-review-dialog .dialog-content .dialog-subtitle {
  font-size: 14px;
  color: #4b5563;
  margin: 0 0 12px 0;
}
.report-review-dialog .dialog-content .radiobtn-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.report-review-dialog .dialog-content .radiobtn-group .reason-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}
.report-review-dialog .dialog-content .radiobtn-group .reason-row .reason-label {
  font-size: 14px;
  color: #111827;
  margin-right: 12px;
}
.report-review-dialog .dialog-content .radiobtn-group .textarea-wrap {
  margin: 4px 0 8px 0;
}
.report-review-dialog .dialog-content .radiobtn-group .textarea-wrap textarea {
  width: 100%;
  min-height: 70px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  resize: vertical;
  font-family: inherit;
}
.report-review-dialog .dialog-actions {
  padding: 25px !important;
  margin: 0 !important;
  border-top: 1px solid #e0e0e0 !important;
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 12px !important;
  background-color: #fff !important;
  flex-shrink: 0;
}
.report-review-dialog .dialog-actions .btn-primary,
.report-review-dialog .dialog-actions .btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  font-family: "Raleway";
  margin: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.report-review-dialog .dialog-actions .btn-primary:disabled,
.report-review-dialog .dialog-actions .btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.report-review-dialog .dialog-actions .btn-primary {
  background: #5ea1d8;
  color: white;
}
.report-review-dialog .dialog-actions .btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.report-review-dialog .dialog-actions .btn-secondary {
  background: #f3f4f6;
  color: #374151;
}
.report-review-dialog .dialog-actions .btn-secondary:hover:not(:disabled) {
  background: #e5e7eb;
}
@media (max-width: 600px) {
  .report-review-dialog {
    display: flex;
    flex-direction: column;
    max-height: 90vh;
  }
  .report-review-dialog .dialog-content {
    flex: 1 1 auto;
    overflow-y: auto;
  }
  .report-review-dialog .dialog-actions {
    position: sticky;
    bottom: 0;
    padding: 12px 16px !important;
  }
}

:host-context(body.theme-dark) {
  /* Radio button circles */
}
:host-context(body.theme-dark) .report-review-dialog,
:host-context(body.theme-dark) .report-review-dialog .dialog-header,
:host-context(body.theme-dark) .report-review-dialog .dialog-content,
:host-context(body.theme-dark) .report-review-dialog .dialog-actions {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .report-review-dialog .dialog-actions {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .report-review-dialog h2,
:host-context(body.theme-dark) .report-review-dialog .dialog-subtitle,
:host-context(body.theme-dark) .report-review-dialog .reason-label,
:host-context(body.theme-dark) .report-review-dialog .close-btn {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .report-review-dialog .textarea-wrap textarea {
  background: #1f2937 !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) .report-review-dialog .btn-secondary {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-radio__outer-circle {
  border-color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-radio--checked .mdc-radio__outer-circle,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-checked .mdc-radio__outer-circle {
  border-color: #ffffff !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-radio--checked .mdc-radio__inner-circle,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-checked .mdc-radio__inner-circle {
  border-color: #ffffff !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__outer-circle {
  border-color: #ffffff !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__inner-circle {
  border-color: #ffffff !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:not(:checked) + .mdc-radio__background .mdc-radio__outer-circle {
  border-color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-radio-button .mat-ripple-element {
  background-color: rgba(255, 255, 255, 0.12) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/report-review-dialog/report-review-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AACJ;AACI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACN;AAEI;EACE,cAAA;AAAN;AAIE;EACE,kBAAA;AAFJ;AAII;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAFN;AAKI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAHR;AAKQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAHV;AAOM;EACE,mBAAA;AALR;AAOQ;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AALV;AAWE;EACE,wBAAA;EACA,oBAAA;EACA,wCAAA;EACA,wBAAA;EACA,oCAAA;EACA,8BAAA;EACA,oBAAA;EACA,iCAAA;EACA,cAAA;AATJ;AAWI;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,wBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;AATN;AAWM;;EACE,YAAA;EACA,mBAAA;AARR;AAYI;EACE,mBAAA;EACA,YAAA;AAVN;AAYM;EACE,mBAAA;AAVR;AAcI;EACE,mBAAA;EACA,cAAA;AAZN;AAcM;EACE,mBAAA;AAZR;AAiBE;EAxHF;IAyHI,aAAA;IACA,sBAAA;IACA,gBAAA;EAdF;EAgBE;IACE,cAAA;IACA,gBAAA;EAdJ;EAiBE;IACE,gBAAA;IACA,SAAA;IACA,6BAAA;EAfJ;AACF;;AAmBA;EAiCE,yBAAA;AAhDF;AAgBE;;;;EAIE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAdJ;AAiBE;EACE,8BAAA;AAfJ;AAkBE;;;;EAIE,yBAAA;AAhBJ;AAmBE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAjBJ;AAoBE;EACE,8BAAA;EACA,yBAAA;EACA,sDAAA;AAlBJ;AAsBE;EACE,gCAAA;AApBJ;AAuBE;;EAEE,gCAAA;AArBJ;AAwBE;;EAEE,gCAAA;AAtBJ;AAyBE;EAEE,gCAAA;AAxBJ;AA2BE;EAEE,gCAAA;AA1BJ;AA6BE;EAEE,gCAAA;AA5BJ;AA+BE;EACE,sDAAA;AA7BJ","sourcesContent":[".report-review-dialog {\n  width: 100%;\n  max-width: 520px;\n  box-sizing: border-box;\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid #e2e8f0;\n\n    h2 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n      color: #0f172a;\n    }\n\n    .close-btn {\n      color: #64748b;\n    }\n  }\n\n  .dialog-content {\n    padding: 16px 20px;\n\n    .dialog-subtitle {\n      font-size: 14px;\n      color: #4b5563;\n      margin: 0 0 12px 0;\n    }\n\n    .radiobtn-group {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      .reason-row {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 6px 0;\n\n        .reason-label {\n          font-size: 14px;\n          color: #111827;\n          margin-right: 12px;\n        }\n      }\n\n      .textarea-wrap {\n        margin: 4px 0 8px 0;\n\n        textarea {\n          width: 100%;\n          min-height: 70px;\n          padding: 8px 10px;\n          border-radius: 6px;\n          border: 1px solid #e5e7eb;\n          font-size: 13px;\n          resize: vertical;\n          font-family: inherit;\n        }\n      }\n    }\n  }\n\n  .dialog-actions {\n    padding: 25px !important;\n    margin: 0 !important;\n    border-top: 1px solid #e0e0e0 !important;\n    display: flex !important;\n    justify-content: flex-end !important;\n    align-items: center !important;\n    gap: 12px !important;\n    background-color: #fff !important;\n    flex-shrink: 0;\n\n    .btn-primary,\n    .btn-secondary {\n      padding: 12px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      border: none;\n      font-family: \"Raleway\";\n      margin: 0 !important;\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n\n    .btn-primary {\n      background: #5ea1d8;\n      color: white;\n\n      &:hover:not(:disabled) {\n        background: #4a8fc4;\n      }\n    }\n\n    .btn-secondary {\n      background: #f3f4f6;\n      color: #374151;\n\n      &:hover:not(:disabled) {\n        background: #e5e7eb;\n      }\n    }\n  }\n\n  @media (max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    max-height: 90vh;\n\n    .dialog-content {\n      flex: 1 1 auto;\n      overflow-y: auto;\n    }\n\n    .dialog-actions {\n      position: sticky;\n      bottom: 0;\n      padding: 12px 16px !important;\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .report-review-dialog,\n  .report-review-dialog .dialog-header,\n  .report-review-dialog .dialog-content,\n  .report-review-dialog .dialog-actions {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .report-review-dialog .dialog-actions {\n    background: #0f172a !important;\n  }\n\n  .report-review-dialog h2,\n  .report-review-dialog .dialog-subtitle,\n  .report-review-dialog .reason-label,\n  .report-review-dialog .close-btn {\n    color: #e2e8f0 !important;\n  }\n\n  .report-review-dialog .textarea-wrap textarea {\n    background: #1f2937 !important;\n    color: #f8fafc !important;\n    border-color: rgba(148, 163, 184, 0.45) !important;\n  }\n\n  .report-review-dialog .btn-secondary {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border: 1px solid rgba(148, 163, 184, 0.35) !important;\n  }\n\n  /* Radio button circles */\n  ::ng-deep .mdc-radio__outer-circle {\n    border-color: #94a3b8 !important;\n  }\n\n  ::ng-deep .mdc-radio--checked .mdc-radio__outer-circle,\n  ::ng-deep .mat-mdc-radio-checked .mdc-radio__outer-circle {\n    border-color: #ffffff !important;\n  }\n\n  ::ng-deep .mdc-radio--checked .mdc-radio__inner-circle,\n  ::ng-deep .mat-mdc-radio-checked .mdc-radio__inner-circle {\n    border-color: #ffffff !important;\n  }\n\n  ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked\n    + .mdc-radio__background .mdc-radio__outer-circle {\n    border-color: #ffffff !important;\n  }\n\n  ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:checked\n    + .mdc-radio__background .mdc-radio__inner-circle {\n    border-color: #ffffff !important;\n  }\n\n  ::ng-deep .mat-mdc-radio-button .mdc-radio .mdc-radio__native-control:enabled:not(:checked)\n    + .mdc-radio__background .mdc-radio__outer-circle {\n    border-color: #94a3b8 !important;\n  }\n\n  ::ng-deep .mat-mdc-radio-button .mat-ripple-element {\n    background-color: rgba(255, 255, 255, 0.12) !important;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
